var ExchangeHolidayMapper = function (ExchangeHolidaydata) {
    if (ExchangeHolidaydata === null || ExchangeHolidaydata === void 0 ? void 0 : ExchangeHolidaydata.data) {
        return {
            BSE: ExchangeHolidayMapperHelper(ExchangeHolidaydata.data.bse),
            NSE: ExchangeHolidayMapperHelper(ExchangeHolidaydata.data.nse),
        };
    }
    return {};
};
var ExchangeHolidayMapperHelper = function (exchangeData) {
    return exchangeData.map(function (holidayEle) {
        return {
            holidayDate: holidayEle.holiday_date,
            purpose: holidayEle.purpose,
        };
    });
};
export default ExchangeHolidayMapper;
